import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PublicMenuItem } from "src/data/publicMenu/queries/publicMenu";
import {
  colorPublicMenuAccent,
  colorPublicMenuDivider,
  colorPublicMenuText,
  colorPublicMenuTextMuted,
} from "src/design/tokens";

interface MenuItemRowProps {
  item: PublicMenuItem;
}

// A single menu item: name + price on one line, description beneath. No per-item
// badge (intentionally excluded from the design). Missing price/description are
// simply not rendered.
export const MenuItemRow = ({ item }: MenuItemRowProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 2.5, borderBottom: `1px solid ${colorPublicMenuDivider}` }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Bogart-regular",
            color: colorPublicMenuText,
            fontSize: { xs: 18, md: 20 },
          }}
        >
          {item.name}
        </Typography>

        {item.price && (
          <Typography
            sx={{
              color: colorPublicMenuAccent,
              fontSize: { xs: 16, md: 18 },
              fontWeight: 600,
              whiteSpace: "nowrap",
            }}
          >
            {t("publicMenu.itemPrice", { price: item.price })}
          </Typography>
        )}
      </Box>

      {item.description && (
        <Typography
          sx={{
            color: colorPublicMenuTextMuted,
            fontSize: { xs: 13, md: 14 },
            lineHeight: 1.6,
            mt: 0.75,
            maxWidth: 640,
          }}
        >
          {item.description}
        </Typography>
      )}
    </Box>
  );
};
